import { calculateEMA } from "./indicators.js";

export function runEmaCrossoverBacktest(history = [], { initialCapital = 10000 } = {}) {
  const data = Array.isArray(history) ? history : [];
  if (data.length < 25) {
    return {
      strategyName: "EMA 9/21 Crossover",
      finalValue: initialCapital,
      returnPercent: 0,
      numberOfTrades: 0,
      winRate: null,
      maxDrawdown: 0,
      trades: [],
      warning: "Недостаточно исторических данных для бэктестинга.",
    };
  }

  const ema9 = calculateEMA(data, 9);
  const ema21 = calculateEMA(data, 21);
  let cash = Number(initialCapital);
  let ounces = 0;
  let entryPrice = null;
  let peakValue = cash;
  let maxDrawdown = 0;
  const trades = [];

  for (let index = 1; index < data.length; index += 1) {
    const price = Number(data[index]?.close ?? data[index]?.price);
    if (!Number.isFinite(price) || !Number.isFinite(ema9[index]) || !Number.isFinite(ema21[index])) continue;
    const previousBullish = Number(ema9[index - 1]) > Number(ema21[index - 1]);
    const currentBullish = Number(ema9[index]) > Number(ema21[index]);
    const crossedUp = !previousBullish && currentBullish;
    const crossedDown = previousBullish && !currentBullish;

    if (crossedUp && cash > 0) {
      ounces = cash / price;
      entryPrice = price;
      trades.push({
        date: data[index]?.date,
        type: "Проверить покупку",
        price,
        ounces,
      });
      cash = 0;
    }

    if (crossedDown && ounces > 0) {
      cash = ounces * price;
      const profit = entryPrice ? price - entryPrice : 0;
      trades.push({
        date: data[index]?.date,
        type: "Снизить риск",
        price,
        profit,
      });
      ounces = 0;
      entryPrice = null;
    }

    const value = cash + ounces * price;
    if (value > peakValue) peakValue = value;
    const drawdown = peakValue > 0 ? ((peakValue - value) / peakValue) * 100 : 0;
    if (drawdown > maxDrawdown) maxDrawdown = drawdown;
  }

  const lastPrice = Number(data[data.length - 1]?.close ?? data[data.length - 1]?.price ?? 0);
  const finalValue = cash + ounces * lastPrice;
  const closedTrades = trades.filter((trade) => trade.type === "Снизить риск");
  const wins = closedTrades.filter((trade) => Number(trade.profit) > 0).length;

  return {
    strategyName: "EMA 9/21 Crossover",
    finalValue,
    returnPercent: initialCapital > 0 ? ((finalValue - initialCapital) / initialCapital) * 100 : 0,
    numberOfTrades: trades.length,
    winRate: closedTrades.length ? (wins / closedTrades.length) * 100 : null,
    maxDrawdown,
    trades: trades.slice(-12),
  };
}
